import { AxiosResponse } from 'axios';
import { appContextGet } from './httpCommon/appAxios.service';
import { StandardParams } from '../types/interfaces/apiParams.interfaces';
import { OnFarmSpecimenLocation } from '../types/interfaces/onFarmSpecimen.interfaces';
import { ON_FARM_SPECIMEN_LOCATION_API_ENDPOINTS } from '../constants/apiEndpoints';

export const getOnFarmSpecimenLocations = (params?: StandardParams): Promise<AxiosResponse<OnFarmSpecimenLocation[], any>> => {
  return appContextGet(ON_FARM_SPECIMEN_LOCATION_API_ENDPOINTS.SPECIMEN_LOCATIONS, params);
};
